var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 2.318c-3.735 0-6.774 3.039-6.774 6.774 0 1.448.468 2.532 1.06 3.904l.085.196c.817 1.901 4.757 7.29 4.924 7.518l.711.971.705-.977c.151-.211 3.739-5.192 4.896-7.461.758-1.487 1.169-2.589 1.169-4.152-.002-3.734-3.041-6.773-6.776-6.773zm4.047 10.131c-.798 1.564-2.935 4.656-4.053 6.242-1.352-1.891-3.507-5.006-4.016-6.191l-.085-.198c-.553-1.279-.917-2.125-.917-3.21 0-2.77 2.254-5.024 5.024-5.024s5.024 2.254 5.024 5.024c0 1.103-.228 1.887-.977 3.357z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 5.983c-1.715 0-3.109 1.395-3.109 3.109 0 1.715 1.395 3.11 3.109 3.11s3.109-1.395 3.109-3.11c0-1.714-1.394-3.109-3.109-3.109zm0 4.719c-.888 0-1.609-.722-1.609-1.61 0-.887.722-1.609 1.609-1.609s1.609.722 1.609 1.609c0 .888-.721 1.61-1.609 1.61z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.983032884391eadecf09a0fe50775e1c.svg";
export { ForwardRef as ReactComponent };